import React, { useMemo } from 'react';
import convertTo12HourFormatObject from 'utils/timeHelpers/convertTo12HourFormatObject';
import convertTo24HourFormatObject from 'utils/timeHelpers/convertTo24HourFormatObject';
import detectTimeFormat from 'utils/timeHelpers/detectTimeFormat';
import TimeInput12Hour from '~/reusable-components/inputs/TimeInput/TimeInput12Hour';
import TimeInput24Hour from '~/reusable-components/inputs/TimeInput/TimeInput24Hour';

interface TimeInputProps {
  defaultValue?: string;
  onChange?: (time: string) => void;
  disabled?: boolean;
  minuteStep?: number;
}

function TimeInput({
  defaultValue,
  onChange,
  disabled,
  minuteStep = 30,
}: TimeInputProps) {
  const { initialTime, inputType } = useMemo(() => {
    const defaultTime = defaultValue || '09:00 AM';
    const resolvedInputType = detectTimeFormat();
    const initialTimeValue =
      resolvedInputType === '12-hour'
        ? convertTo12HourFormatObject(defaultTime)
        : convertTo24HourFormatObject(defaultTime);

    return {
      inputType: resolvedInputType,
      initialTime: initialTimeValue,
    };
  }, [defaultValue]);

  if (inputType === '12-hour') {
    return (
      <TimeInput12Hour
        defaultValue={initialTime}
        onChange={onChange}
        disabled={disabled}
        minuteStep={minuteStep}
      />
    );
  }

  return (
    <TimeInput24Hour
      defaultValue={initialTime}
      onChange={onChange}
      disabled={disabled}
      minuteStep={minuteStep}
    />
  );
}

export default TimeInput;
